const translations = {
  "en": {
    "Back": "Back"
  },
  "zh-tw": {
    "Back": "返回"
  }
};

export default translations;
